import {get, put, post, del} from '@/common/api'

let pre = '/api';
let api = {
    /** ****************** 日结 ****************** **/
    getCurrentSettleDate() {
        return get('/api/op/closing/date');
    },
    queryCashierSettle() {
        return get(`${pre}/op/closing/cashier`);
    },
    execDailySettle(para) {
        return post('/api/op/closing', para);
    },
    queryEntities(para) {
        return get('/api/op/closing', para);
    },
    deleteClosing(id) {
        return del(`/api/op/closing/${id}`);
    },
    getCashierFeeType(para) {
        return get('/api/op/closing/cashier/type/fee', para);
    },
    getCahierPayType(para) {
        return get('/api/op/closing/cashier/type/pay', para);
    },
    getCahierInvoices(para) {
        return get('/api/op/closing/cashier/invoices', para);
    },
    getFeeType(para) {
        return get('/api/op/closing/cashier/type/fee', para);
    },
    getChannelAccount(id) {
        return get(`/api/op/closing/channel/${id}`);
    },
    // 总金额接口
    getAccount(para) {
        return get('/api/op/closing/cashier/amount', para);
    },
    getCashier(para) {
        return get(`/api/op/closing/cashier`, para);
    },
    getPayChannel(para) {
        return get(`/api/op/closing/channel/pay`, para);
    },
    getRpFeeType(para) {
        return get('/api/op/closing/type/fee', para);
    },
}
export default api
